import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { IoClose } from "react-icons/io5"; // Import de l'icône pour le bouton de fermeture
import "./ContactModal.css"; // Import du fichier CSS

const ContactModal = ({ isOpen, onClose }) => {
    const formRef = useRef(null);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_bfav1hb",
                "template_ttivkh2",
                formRef.current,
                "aJBFC8uDb4dLa5Bn4"
            )
            .then((result) => {
                console.log("EmailJS result:", result.text);
                setShowConfirmation(true);
                setTimeout(() => {
                    setShowConfirmation(false);
                    onClose(); // Ferme la modale après confirmation
                }, 2000);
            })
            .catch((error) => {
                console.error("EmailJS error:", error);
            });

        e.target.reset();
    };

    if (!isOpen) return null;

    return (
        <div className="contact-modal-overlay" onClick={onClose}>
            <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
                {/* Bouton de fermeture avec icône */}
                <button onClick={onClose} className="close-button">
                    <IoClose />
                </button>

                <h2>Contactez-nous</h2>

                <form ref={formRef} onSubmit={handleSubmit}>
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Votre Téléphone"
                        required
                    />
                    <textarea
                        name="message"
                        placeholder="Votre Message (optionnel)"
                    ></textarea>
                    <button type="submit">Envoyer</button>
                </form>

                {showConfirmation && (
                    <div className="confirmation-message">
                        Votre message a été envoyé avec succès !
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactModal;
